import { orderBy } from 'lodash-es';
import { useMemo } from 'react';
import { Content } from '../services/UploadManagementServiceTypes';
import { SortField, SortOrder } from '../../hooks/useSortSettings';

const getLowerCaseName = (content: Content) => content.name?.toLowerCase();

const getLatestChange = (content: Content) => new Date(content.modifiedAt || content.createdAt);

export const sortContentBy = (
  contents: Content[],
  field: SortField,
  order: SortOrder,
): Content[] => {
  if (field === 'modifiedAt') {
    return orderBy(contents, getLatestChange, order);
  }
  if (field === 'type') {
    return orderBy(contents, ['contentType.name', getLowerCaseName], [order, 'asc']);
  }
  if (field === 'name') {
    return orderBy(contents, getLowerCaseName, order);
  }
  return contents;
};

export const useContentSort = (contents: Content[], sortField: SortField, sortOrder: SortOrder) => {
  return useMemo(
    () => sortContentBy(contents, sortField, sortOrder),
    [sortField, sortOrder, contents],
  );
};
